import get from "lodash.get";
import pick from "lodash.pick";
import {VIEW_MODE} from '../../../hooks/useViewMode'
import {
	ISOLATED_PRODUCT,
	validStreamStoreIDS,
} from "../../../store";
import {
	SYSTEM_ID_ICUE,SYSTEM_ID_TOGGLE_DESK_CAMERA,
	SYSTEM_ID_TOGGLE_DOOR,
	SYSTEM_ID_TOGGLE_INSPECT,
	SYSTEM_ID_TOGGLE_POWER
} from "../../../contants/presets";

const storedKeys = [
	SYSTEM_ID_ICUE,
	SYSTEM_ID_TOGGLE_POWER,
	SYSTEM_ID_TOGGLE_DOOR,
	SYSTEM_ID_TOGGLE_INSPECT,
	SYSTEM_ID_TOGGLE_DESK_CAMERA,
]

export const applyIconDataNew = props => el => {
	const cbArr = Array.isArray(props) ? props : [props];
	return {
		...el,
		iconData: {
			...el.iconData,
			...cbArr.reduce((acc, cb) => {
				acc = {
					...acc,
					...cb(el),
				};
				return acc;
			}, {}),
		}
	}
};

export const applyEvents = (collection, getBy = 'id') => el => {
	return {
		...el,
		...collection.get(get(el, getBy), el)
	};
};

export const applyProp = (key, {conditions = {}, getBy = 'id', isNegation = false} = {}) => el => {
	const isObjectType = typeof conditions === 'object';
	const isArray = Array.isArray(conditions);
	const isObject = !isArray && isObjectType && conditions !== null;
	const field = get(el, getBy)
	let value;
	
	if(isArray) {
		value = ~conditions.indexOf(field);
	} else if(isObject) {
		const condition = conditions[field];
		value = typeof condition === 'function' && condition(el);
	}
	return {
		...el,
		[key]: (isNegation ? !value : value),
	}
}

export const applyProperties = data => el => {
	return Object.entries(data)
		.reduce((acc, [key, props]) => {
			acc = {
				...acc,
				...applyProp(key, props)(el),
			};
			return acc;
		}, el);
}

export const getStoredData = data => pick(data, [
	VIEW_MODE,
	ISOLATED_PRODUCT,
	...storedKeys,
])

export const prepareHardcodedOptions = items => items.map(el => {
		return {
			...el,
			productId: el.productId ? el.productId : el.id,
			hardcoded: !!~el.id.indexOf('hardcode'),
			price: el.price || 0,
		}
	}
);

export const makeAnObject = (props) => typeof props === "string" ? JSON.parse(props) : props || {};

export const validateResponse = (props) => pick(props, validStreamStoreIDS);

/*@TODO That is, probably, can be removed*/
export const reduceApplicationResponse = (props) => {
	let data = null;
	let valid;

	try {
		data = validateResponse(props)
		valid = true
	} catch (e) {
		valid = false;
	}
	
	return {
		data,
		valid,
	};
}

export const timeTranslations = {
	de: {
		minutes: value => value > 1 ? "Minuten" : "Minute",
		seconds: value => value > 1 ? "Sekunden" : "Sekunde",
		hours: value => value > 1 ? "Stunden" : "Stunde",
	}
};

export const determineTimeValue = (typeValue, value, lang = 'de') => {
	return timeTranslations[lang][typeValue](value)
};